'use strict';
var PassengersCollection = Backbone.Collection.extend({
    model: require('../models/passenger.model'),
    dataUrl: 'gettravellers',
    nTravellers: 0,
    initialize: function() {
    },
    getPassenger: function(searchPattern) {
        return this.findWhere(searchPattern);
    },
    url: function() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },
    parse: function(data) {
        return Odigeo._.map(data, function(passenger, i) {
            return {
                index: i,
                numPassenger: i + 1,
                name: '',
                defaultName: '' + (i + 1),
                firstLastName: '',
                shortName: 'P' + (i + 1),
                defaultShortName: 'P' + (i + 1),
                travellerType: passenger.travellerType,
            };
        });
    },
    populatePassengers: function() {
        this.fetch(this.getDataRequestSettings());
    },
    getDataRequestSettings: function() {
        return {
            type: 'GET',
            cache: false,
            dataType: 'json',
            contentType: 'application/json',
            success: Odigeo._.bind(this.requestSuccessHandler, this),
        };
    },
    requestSuccessHandler: function() {
        this.trigger('passengerCollectionIsOk');
    },
    setUp: function() {
        this.populatePassengers();
    },
    updatePassengers: function() {
        var travellers = Odigeo.Storage.get('passengersData') || Odigeo.Session.get('passengersData') || null;
        if (!Odigeo._.isNull(travellers)) {
            Odigeo._.each(this.getPassengersStorageInfo(travellers), function(passenger) {
                this.setPassengerNewData(passenger);
            }, this);
        }
        return this.models;
    },

    getPassengersStorageInfo: function(travellers) {
        var allPassengers = JSON.parse(travellers);
        var passengers = [];
        Odigeo._.each(allPassengers, Odigeo._.bind(function(passenger) {
            if ((!Odigeo._.isEmpty(passenger.name)) && (!Odigeo._.isEmpty(passenger.firstLastName))) {
                passengers.push({
                    name: passenger.name,
                    firstLastName: passenger.firstLastName,
                    shortName: passenger.name.charAt(0) + passenger.firstLastName.charAt(0),
                    numPassenger: passengers.length,
                    travellerType: passenger.travellerType,
                });
            }
        }, this));
        return passengers;
    },

    setPassengerNewData: function(passenger) {
        var model = this.getPassenger({numPassenger: passenger.numPassenger + 1});
        if (!Odigeo._.isUndefined(model)) {
            model.set({name: passenger.name, firstLastName: passenger.firstLastName, shortName: passenger.shortName});
        }
    },

    updatePassengersManager: function() {
        var travellers = Odigeo.Storage.get('passengersData') || Odigeo.Session.get('passengersData') || null;
        if (!Odigeo._.isNull(travellers)) {
            Odigeo._.each(this.getPassengersManagerStorageInfo(travellers), function(passenger) {
                this.setPassengerNewData(passenger);
            }, this);
        }
        return this.models;
    },

    getLastNumPassengerExcludingType: function(passengerTypeToExclude) {
        return this.reduceRight(function(lastNumPax, currentPax) {
            lastNumPax = currentPax.get('travellerType') !== passengerTypeToExclude && lastNumPax === 0 ?
                currentPax.get('numPassenger') : lastNumPax;
            return lastNumPax;
        }, 0);
    },

    getPassengersManagerStorageInfo: function(travellers) {
        var allPassengers = JSON.parse(travellers);
        var passengers = [];
        Odigeo._.each(Odigeo._.filter(allPassengers, function(passenger) {
            return !!passenger.name;
        }),
        function(passenger) {
            passengers.push({
                name: passenger.name,
                firstLastName: passenger.firstLastName,
                numPassenger: passengers.length,
            });
        });
        return passengers;
    },

    containPassengerType: function(type) {
        return this.where({travellerType: type}).length > 0;
    },

    passengerCountByType: function(type) {
        return this.where({travellerType: type}).length;
    },
});
var instance;

module.exports.getInstance = function() {
    if (Odigeo._.isUndefined(instance)) {
        instance = new PassengersCollection();
    }
    return instance;
};
